import Scene360 from "./Scene360";
import SceneSplitOther from "./SceneSplitOther";

/**
 * Represents a 360 scene within the player
 */
export default class SceneSplit extends Scene360 {
  /**
   * Takes an image config object and creates the initial 360 scene
   *
   * @example
   * {
   *   url: '/example.jpg',
   *   hotspots: [
   *     {
   *       u: 0,
   *       v: 0.5,
   *       type: 'web',
   *       options: {
   *         url : 'http://google.com'
   *       }
   *     }
   *   ]
   * }
   *
   */
  constructor(player, image1, image2, onFullyLoaded = () => {}) {
    super(player, image1, onFullyLoaded);
    this.SCENE_NAME = "SceneSplit";
    this._player = player;

    const other = new SceneSplitOther(player, image2, () => {});
    other.loadFullRes?.();
    this._otherScene = other;
    this.split = true;
    this.isOther = false;
  }

  dispose() {
    if (this._photoHolder) {
      this.group.remove(this._photoHolder);
      this._photoHolder.dispose();
      this._photoHolder = undefined;
    }
    this._otherScene.dispose();
    super.dispose();
  }
}
